import { FC } from 'react';
import dangerIcon from 'images/danger-icon.svg';

const ExpertiseIcon: FC = (props): JSX.Element => {
  return <img src={dangerIcon} alt="danger-icon" />;
};
export default ExpertiseIcon;
